// extracted by mini-css-extract-plugin
export default {"checkbox":"auoTzv","checkboxError":"ql2UWS"};